const SAFE_PROTOCOLS = new Set(["http:", "https:", "mailto:"]);

/** Returns the URL when it is http(s) or mailto; otherwise empty (drop javascript:/data:). */
export function transformMarkdownUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return "";
  try {
    const parsed = new URL(trimmed, "https://grantonomy.invalid");
    return SAFE_PROTOCOLS.has(parsed.protocol) ? trimmed : "";
  } catch {
    return "";
  }
}
